module.exports = __webpack_public_path__ + "img/set-up.cd6793ff.svg";